import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { formatDate } from '../../lib/Dates'
import { Sheet } from '../../lib/Types'
import Text from '../Elements/Text'
import { getTrialEndDate } from './lib/Payment'

interface Props {
  sheet: Sheet
  overdue: boolean
  onActiveTrial: boolean
  isPaid?: boolean
  isFree?: boolean
  freeInPremiumPeriod?: boolean
}

const TrialLabel: FC<Props> = ({
  sheet,
  overdue,
  onActiveTrial,
  isPaid,
  isFree,
  freeInPremiumPeriod,
}) => {
  const { t } = useTranslation('common')

  if (overdue) {
    return (
      <Text size='sm' className='!text-red-600'>
        {t('common:trial.ended', {
          date: formatDate(getTrialEndDate(sheet), 'dd/mm'),
        })}
      </Text>
    )
  }

  if (onActiveTrial) {
    return (
      <Text size='sm' className='!text-green-700'>
        {t('common:trial.active', {
          date: formatDate(getTrialEndDate(sheet), 'dd/mm'),
        })}
      </Text>
    )
  }

  // Checked before isFree — a budget can be both is_free and paid/accepted
  // (e.g. a free budget that was later upgraded), and paid status wins:
  // no label once paid, regardless of the free flag.
  if (isPaid) {
    return null
  }

  if (isFree) {
    return (
      <Text size='sm' className='!text-gray-600'>
        {freeInPremiumPeriod
          ? t('common:trial.freeWithPremium', {
            date: formatDate(getTrialEndDate(sheet), 'dd/mm'),
          })
          : t('common:trial.free')}
      </Text>
    )
  }

  return null
}

export default TrialLabel
